import { HomefieldIconPrivacyOptions } from '@dsg-tech/homefield-react-icons';
import { ActionText, TextLink } from '@dsg-tech/homefield-react';
import { openSurveyLink, replaceSpaceAndCapitalize } from 'utility/utility';
import { CTA } from 'types';
import './FooterLinks.scss';

interface FooterLinkProps {
  content: CTA;
}

const FooterLink = ({ content }: FooterLinkProps) => {
  const handleClick = (id: string) => {
    openSurveyLink(id);
    setTimeout(() => {
      const element = document.getElementById('kampyleFormContainer');
      element?.scrollIntoView({ behavior: 'smooth' });
    }, 800);
  };

  const createFooterLink = (linkText: string) => {
    if (typeof linkText !== 'string') return '';
    if (linkText.startsWith('/') || linkText.startsWith('http')) return linkText;
    return `/${linkText}`;
  };

  if (content.linkTitle === 'Site Feedback') {
    return (
      <div className="footer-link hmf-display-flex hmf-justify-content-center">
        <ActionText
          variant="group"
          size="small"
          data-em={`Footer_${replaceSpaceAndCapitalize(content.linkTitle).replace(/\s/g, '')}`}
          onClick={() => handleClick(content.link)}>
          {content.linkTitle}
        </ActionText>
      </div>
    );
  }

  return (
    <div className="footer-link hmf-display-flex hmf-justify-content-center">
      <span className="hmf-display-flex hmf-align-items-center">
        <TextLink
          variant="group"
          size="small"
          href={createFooterLink(content.link)}
          data-em={`Footer_${replaceSpaceAndCapitalize(content.linkTitle).replace(/\s/g, '')}`}>
          <>{content.linkTitle}</>
        </TextLink>
        {content.linkTitle === 'Your Privacy Choices' && (
          <HomefieldIconPrivacyOptions
            height="24"
            width="24"
            className="hmf-pl-xxxs privacy-icon"
          />
        )}
      </span>
    </div>
  );
};

const FooterLinks = ({ cta }: { cta: CTA[] }) => {
  return (
    <div
      data-testid="FooterLinks"
      className="footer-links-container hmf-display-flex hmf-flex-wrap hmf-justify-content-center hmf-mx-auto">
      {cta.map((content) => (
        <FooterLink key={content.link} content={content} />
      ))}
    </div>
  );
};

export default FooterLinks;
